<template>
  <div>
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="lab">供应商名称：</div>
          <div class="val">{{ psuInfo.psucomfullname }}</div>
        </div>
        <div class="view-row">
          <div class="lab">状态：</div>
          <div class="val">
            <el-select
              v-model="psuInfo.psustatus"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in psu_Status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="view-row" v-if="+psuInfo.psubidflg === 1">
          <div class="lab">成交通知书：</div>
          <div class="val">
            <el-select
              v-model="psuInfo.psubcnflg"
              :clearable="true"
              placeholder="请选择"
            >
              <el-option
                v-for="item in psubcnflg_Status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-if="+psuInfo.psubidflg === 1">
          <div style="display: flex">
            <div class="lab">电子合同：</div>
            <div class="val">
              <upload-btn
                @changed="setfileAppend"
                text="上传电子合同"
              ></upload-btn>
            </div>
          </div>
          <div>
            <div
              v-if="appends"
              style="margin-left: 70px; margin-top: 10px; margin-bottom: 20px"
            >
              <div style="color: #2f74ff; cursor: pointer; padding-left: 20px">
                <span @click="downFile(appends.appendurl)">
                  <a :src="$store.getters.uploadAddr + appends.appendurl">{{
                    appends.appendfilename
                  }}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer" style="overflow:hidden">
      <el-button type="primary" @click="savePsu" style="float:right;">确定</el-button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

import uploadBtn from "../../common/uploadBtn";
export default {
  name: "RegistrationStatus",
  data() {
    return {
      loading: false,
      psu_Status: [
        { value: "1", label: "待审" },
        { value: "2", label: "驳回" },
        { value: "3", label: "通过" },
        { value: "4", label: "拒绝" },
      ],
      psubcnflg_Status: [
        { value: 1, label: "未提交" },
        { value: 2, label: "已提交" },
      ],
    };
  },
  props: {
    psuInfo: Object,
    appends: Object,
  },
  components: {
    uploadBtn,
  },
  methods: {
    async savePsu() {
      //   this.loading = true;
      await request({
        method: "post",
        url: "/xtgl/status/savePsu",
        data: {
          psustatus: this.psuInfo.psustatus,
          psuid: this.psuInfo.psuid,
          psubcnflg: this.psuInfo.psubcnflg,
          appends: this.appends,
        },
      });
      this.$emit('reloadStatus')
      //   this.loading = false;
    },
    async setfileAppend(path, filename) {
      let data = {
        appendid: 0,
        appendfromid: this.psuInfo.psuid,
        appendfromtype: 21,
        appendtype: "100",
        appendseq: 1,
        appendfilecode: "",
        appendfilename: filename,
        appendurl: path.replace(this.uploadAddr, ""),
      };
      this.appends = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.split-box {
  margin: 11px 0 15px;
  .split-line {
    margin: 5px;
  }
  .split-name {
    font-weight: bold;
  }
}
</style>
